import DermaVisitaList from "./pages/DermaVisitaList.vue"
import DermaVisitaEdit from "./pages/DermaVisitaEdit.vue"
import DermaVisitaView from "./pages/DermaVisitaView.vue"


export default {
    DermaVisitaList,
    DermaVisitaEdit,
    DermaVisitaView,
  };